import * as React from "react";
import {Popover, SimpleMenuItems} from "@octopusdeploy/design-system-components";
import IconButton, {Icon} from "components/IconButton/IconButton";
import styles = require("./SimpleSelect.less");

export interface SimpleSelectItem {
    value: string;
    text: string;
}

export interface SimpleSelectProps {
    label?: React.ReactNode;
    value: string | undefined;
    onChange(newValue: string): void;
    items: SimpleSelectItem[];
    disabled?: boolean;
    placeholder?: string;
    error?: string;
}

interface State {
    open: boolean;
    anchorEl: HTMLDivElement | null;
}

export default class SimpleSelect extends React.Component<SimpleSelectProps, State> {
    private rootEl: HTMLDivElement | null = null;

    state: State = {open: false, anchorEl: null};

    private toggleOpen = (e?: React.MouseEvent) => {
        if (this.props.disabled) return;
        // The row and the IconButton both wire up to this handler; stopPropagation
        // prevents the IconButton click from also firing the row's onClick (toggling twice).
        e?.stopPropagation();
        this.setState(s => ({open: !s.open, anchorEl: this.rootEl}));
    };

    private handleClose = () => this.setState({open: false});

    private handleSelect = (value: string) => {
        this.props.onChange(value);
        this.setState({open: false});
    };

    render() {
        const {label, value, items, disabled, placeholder, error} = this.props;
        const selected = items.find(i => i.value === value);
        const displayText = selected ? selected.text : "";
        const hasValue = !!displayText;
        const menuItems = items.map(i => ({
            type: "button" as const,
            label: i.text || " ",
            onClick: () => this.handleSelect(i.value),
            isSelected: !!i.text && i.value === value,
        }));

        return (
            <div className={styles.container} ref={el => { this.rootEl = el; }}>
                {label && <label className={styles.label} style={!hasValue ? {visibility: "hidden"} : {}}>{label}</label>}
                <div className={styles.row} onClick={this.toggleOpen}>
                    <span className={hasValue ? styles.value : styles.placeholder}>
                        {hasValue ? displayText : (placeholder || (typeof label === "string" ? label : "") || "")}
                    </span>
                    <div className={styles.iconContainer}>
                        <IconButton
                            icon={Icon.ArrowDown}
                            disabled={disabled}
                            onClick={this.toggleOpen}
                        />
                    </div>
                </div>
                <div className={error ? styles.underlineError : styles.underline} />
                {error && <div className={styles.error}>{error}</div>}
                <Popover
                    open={this.state.open}
                    anchorEl={this.state.anchorEl}
                    placement="bottom-start"
                    onClose={this.handleClose}
                    accessibleRole="menu"
                    accessibleName={typeof label === "string" ? `Select ${label}` : "Select"}
                >
                    <div className={styles.menuContainer}>
                        <SimpleMenuItems items={menuItems} onClose={this.handleClose} />
                    </div>
                </Popover>
            </div>
        );
    }
}
